import React from "react"
import BBHCPlaceHolderImage from "../../../assets/images/bbhc/image 53.png"
import BootcampImage1 from "../../../assets/images/bootcamp/bootcamp1.png"
import { Badge } from "../../../components/ui/badge"
import { Button } from "../../../components/ui/button"
import { SvgArrowRight } from "../../../components/icons"
import { useNavigate } from "react-router-dom"

interface Props {
  pathname: string
  jotformRef?: React.RefObject<HTMLDivElement>
  isBootcamp?: boolean
  isCountdownActive?: boolean
}

const BusinessHero: React.FC<Props> = ({
  pathname,
  jotformRef,
  isBootcamp,
  isCountdownActive,
}) => {
  const navigate = useNavigate()

  const handleBBHCCreateAccount = () => {
    navigate("/iin-registration", { state: { from: pathname } })
  }

  const handleBootcampRegistration = () => {
    navigate("/5daybusinessbootcamp/registration")
  }

  return (
    <>
      <div
        className="md:pt-[96px] pt-[48px] md:pb-[96px] pb-[56px] px-6 md:px-[120px] flex flex-col overflow-hidden"
        style={{
          fontFamily: "BeausiteClassic",
        }}
      >
        <div className="w-full max-w-screen-xl mx-auto flex flex-col md:flex-row items-center gap-20 justify-between">
          {/* Left Content */}
          <div className="md:w-[720px] flex flex-col gap-4 md:gap-6">
            <div className="flex flex-col items-start">
              <h1 className="text-[#0D0D0D] mb-1 font-bold text-5xl md:text-[64px] md:leading-tight md:tracking-[-0.06em]">
                {isBootcamp ? (
                  <>
                    <span className="whitespace-normal lg:whitespace-nowrap">
                      {" "}
                      From Purpose to Profit:
                    </span>{" "}
                    <br />
                    The 5-Day Business Bootcamp for Coaches
                  </>
                ) : (
                  <>
                    Business Blueprint <br />
                    <span className="font-normal italic">for</span> Health
                    Coaches
                  </>
                )}
              </h1>
              <p
                className="text-[#4750F5] font-medium text-[20px] leading-[24px]"
                style={{
                  maxWidth: "550px",
                  whiteSpace: "normal",
                  fontFamily: "BeausiteClassic",
                  letterSpacing: "-0.07em",
                  textAlign: "left",
                }}
              >
                {isBootcamp
                  ? "Build a Coaching Business That Lasts"
                  : "Your Complete Business Solution Exclusively for IIN Alumni"}
              </p>
            </div>

            <div className="flex flex-col gap-4 mt-4">
              {isBootcamp ? (
                <>
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="font-light leading-relaxed text-left"
                  >
                    Ready to launch, grow, or uplevel your practice? Join Zoee’s
                    5-Day Business Bootcamp for Coaches: a transformational,
                    action-packed training designed to help you cut through the
                    noise and build a business that’s simple, profitable, and
                    aligned with who you are.
                  </p>{" "}
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="font-light leading-relaxed text-left"
                  >
                    {" "}
                    In just 5 days, you’ll climb Zoee’s Hierarchy of Needs for
                    Coaches™, establishing your foundations, implementing your
                    business model, and creating a sales & marketing system that
                    actually works. By the end, you’ll walk away with a clear
                    roadmap you can use to grow your business with clarity and
                    confidence for years to come.
                  </p>
                  {/* <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="font-light leading-relaxed text-left"
                  >
                    The 5-Day Business Bootcamp has been rescheduled for January
                    2026. Limited spots available. Register by{" "}
                    <span className="font-bold">TBD</span> to secure your seat.
                  </p> */}
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="font-light leading-relaxed text-left"
                  >
                    <span className="font-bold">
                      Limited seats are available
                    </span>{" "}
                    for this exclusive 5-day training. Enroll by{" "}
                    <span className="font-bold">January 11th, 2026</span> to
                    reserve your spot! Special Price{" "}
                    <span className="font-bold">$556</span>, normally{" "}
                    <span className="font-bold">$695</span> ($1,500 value).
                  </p>
                  <div className="-ml-2 leading-relaxed text-left">
                    <Badge
                      variant="custom"
                      className="bg-luminousAmber px-4 py-2 text-[16px] font-bold flex flex-col items-start gap-0 w-fit"
                    >
                      <span>NBHWC Accredited – 7.5 CCE Credits</span>
                      <span className="text-[14px] font-medium font-normal -mt-1">
                        Course Number:{" "}
                        <span className="font-bold">CEA-100185-1</span>
                      </span>
                    </Badge>

                    <Badge
                      variant="custom"
                      className="bg-[#99D1B3] px-4 py-3 mt-2 text-[16px] font-bold w-fit"
                    >
                      ICF Accredited – 7.5 CCE Credits
                    </Badge>
                  </div>
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="leading-relaxed text-left font-bold"
                  >
                    Program dates: January 12-16, 2026
                  </p>
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="leading-relaxed text-left font-bold"
                  >
                    Time: 12 PM EST - 1:30 PM EST (90 minutes each day)
                  </p>
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="leading-relaxed text-left font-bold"
                  >
                    Format: Live virtual training
                  </p>
                </>
              ) : (
                <>
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="font-light leading-relaxed text-left"
                  >
                    Looking for support in launching, relaunching, or growing
                    your coaching business? IIN and Zoee are proudly partnering
                    to help IIN Health Coaches kickstart and accelerate their
                    coaching careers and generate income with less effort.
                  </p>
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="font-light leading-relaxed text-left"
                  >
                    Expertly crafted, this transformational program combines
                    IIN's tried-and-true business methodology with Zoee’s
                    cutting-edge all-in-one coaching platform. Build or scale
                    your business in just 3 months using the Health Coach
                    Business Blueprint — a step-by-step customizable strategy
                    for achieving your career goals with clarity, ease, and
                    authenticity.
                  </p>
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="font-light leading-relaxed text-left"
                  >
                    Pre registration now available.{" "}
                    <span className="text-[#4750F5] font-bold">
                      Now until Devember 15th, 2025!
                    </span>{" "}
                    Secure your seat.
                  </p>
                  <p
                    style={{ fontSize: "16px", color: "#0D0D0D" }}
                    className="font-light leading-relaxed text-left"
                  >
                    Program dates:{" "}
                    <span className="font-bold">January 13–18, 2026</span>
                  </p>
                </>
              )}
              <div className="flex justify-center md:justify-start">
                {isBootcamp ? (
                  isCountdownActive ? (
                    <Button
                      variant="default"
                      onClick={handleBootcampRegistration}
                      className="px-6 py-3 bg-[#4750F5] text-white font-bold rounded-lg flex items-center gap-2"
                    >
                      <span>{"\u{1F449}"}</span> SAVE YOUR SEAT
                    </Button>
                  ) : (
                    <Button
                      variant="default"
                      asChild
                      className="px-6 py-3 bg-[#4750F5] text-white font-bold rounded-lg flex items-center gap-2"
                    >
                      <a
                        href="https://form.jotform.com/253005569459161"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span>{"\u{1F449}"}</span> JOIN WAITLIST
                      </a>
                    </Button>
                  )
                ) : (
                  <Button
                    variant="default"
                    onClick={handleBBHCCreateAccount}
                    className="px-6 py-3 bg-[#4750F5] text-white font-bold rounded-lg flex items-center gap-2"
                  >
                    SAVE YOUR SEAT <SvgArrowRight />
                  </Button>
                )}
              </div>
              {isCountdownActive && (
                <div className="mt-10 text-left font-lightleading-relaxed">
                  {isBootcamp ? (
                    <p className="text-[16px] text-[#ODODOD]">
                      If you're unable to attend our January 2026 bootcamp, join
                      the waitlist to be the first to know about future bootcamp
                      dates and continue your journey toward building a thriving
                      coaching practice.
                    </p>
                  ) : null}
                  {/* Waitlist Button */}
                  <Button
                    asChild
                    variant="default"
                    className="mt-4 px-6 py-3 bg-blurple text-white font-bold rounded-lg inline-flex items-center gap-2 w-auto"
                  >
                    <a
                      href="https://form.jotform.com/253005569459161"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>{"\u{1F449}"}</span> JOIN WAITLIST
                    </a>
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className="">
            {isBootcamp ? (
              <img
                className="max-w-full lg:max-w-[80%] rounded-md shadow-lg"
                src={BootcampImage1}
                alt="Program Visual"
              />
            ) : (
              <img
                className="max-w-full lg:max-w-[80%] rounded-md shadow-lg"
                src={BBHCPlaceHolderImage}
                alt="Program Visual"
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default BusinessHero
